import { render, staticRenderFns } from "./VirtualCompanyEntry.vue?vue&type=template&id=6c30c60e&scoped=true"
import script from "./VirtualCompanyEntry.vue?vue&type=script&lang=js"
export * from "./VirtualCompanyEntry.vue?vue&type=script&lang=js"
import style0 from "./VirtualCompanyEntry.vue?vue&type=style&index=0&id=6c30c60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30c60e",
  null
  
)

export default component.exports